<template>
	<div class="login" v-if="isShowlogin">
		<div class="center" v-if="typei<2">
			<div class="title">用户登录</div>
			<!--<ul class="type">
				<li :class="{'on':typei==0}" @click="changeType(0)">个人登录</li>
				<li :class="{'on':typei==1}" @click="changeType(1)">团体登录</li>
			</ul>-->
			<!--个人用户登录-->
			<ul class="form" v-if="typei==0">
				<li>
					<div class="c1">邮箱</div>
					<div class="c2">
						<input :class="{'error':!isPhone}" v-model="form1.phone" placeholder="请输入邮箱" @change="checkPhone" />
					</div>
				</li>
				<li>
					<div class="c1">图形验证码</div>
					<div class="c2">
						<input class="short" :class="{'error':!isCheckimg}" v-model="form1.code" placeholder="请输入图形验证码" @blur="checkImg" />
						<img class="codeimg" :src="form1.codeimg" @click="getCheckimg" />
					</div>
				</li>
				<li>
					<div class="c1">邮箱验证码</div>
					<div class="c2">
						<input class="short" v-model="form1.smscode" placeholder="请输入邮箱验证码" />
						<a class="sendcode" :class="{'gray':sendCount}" @click="sendMsg">获取验证码<span v-if="sendCount">({{sendCount}}s)</span></a>
					</div>
				</li>
				<li style="padding: 0;">
					<button class="submit" @click="submit">立即登录</button>
				</li>
			</ul>
			<!--团体用户登录-->
			<ul class="form" v-if="typei==1">
				<li>
					<div class="c1">邮箱</div>
					<div class="c2">
						<input :class="{'error':!isPhone2}" v-model="form2.phone" placeholder="请输入邮箱" @change="checkPhone2" />
					</div>
				</li>
				<li>
					<div class="c1">密码</div>
					<div class="c2">
						<input :class="{'error':!isPwd}" v-model="form2.pwd" placeholder="请输入密码" @change="checkPwd" @keyup.enter="submit2" />
					</div>
					<p class="findpwd"><a @click="findPwd">忘记密码？</a></p>
				</li>
				<li style="padding: 0;">
					<button class="submit" @click="submit2">立即登录</button>
					<p class="regtip">没有账号？&nbsp;<a @click="regTeam">立即注册</a></p>
				</li>
			</ul>
			<a class="close" @click="closeLogin"><Icon type="md-close" color="#8E8E91" size="40" /></a>
		</div>
		<!--找回密码-->
		<div class="center" v-if="typei==2">
			<div class="title">修改/找回密码</div>
			<ul class="form" v-if="!findSuccess">
				<li>
					<div class="c1">邮箱</div>
					<div class="c2">
						<input v-model="form3.phone" placeholder="请输入邮箱" />
					</div>
				</li>
				<li>
					<div class="c1">图形验证码</div>
					<div class="c2">
						<input class="short" :class="{'error':!isCheckimg3}" v-model="form3.code" placeholder="请输入图形验证码" @blur="checkImg3" />
						<img class="codeimg" :src="form3.codeimg" @click="getCheckimg3" />
					</div>
				</li>
				<li>
					<div class="c1">邮箱验证码</div>
					<div class="c2">
						<input class="short" v-model="form3.smscode" placeholder="请输入邮箱验证码" />
						<a class="sendcode" :class="{'gray':sendCount3}" @click="sendMsg3">获取验证码<span v-if="sendCount3">({{sendCount3}}s)</span></a>
					</div>
				</li>
				<li>
					<div class="c1">输入新密码</div>
					<div class="c2">
						<input v-model="form3.password" placeholder="请输入新密码（限制6-32位字符）" />
					</div>
				</li>
				<li>
					<div class="c1">确认密码</div>
					<div class="c2">
						<input v-model="form3.password_confirmation" placeholder="请确认密码（限制6-32位字符）" />
					</div>
				</li>
				<li>
					<button class="submit" @click="submit3">提交</button>
				</li>
			</ul>
			<a v-if="!findSuccess" class="close" @click="closeLogin"><Icon type="md-close" color="#8E8E91" size="40" /></a>
			<div class="findsuccess" v-if="findSuccess">
				<div class="tip">
					<img src="static/img/success.png" />
					<span>恭喜，修改密码成功！</span>
				</div>
				<button class="submit" @click="toTeamlogin">立即登录</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'login',
	data () {
	    return {
	    	typei: 0,
	    	isShowlogin: false,
	    	form1: {
	    		phone: "",
	    		code: "",
	    		codeimg: "",
	    		smscode: ""
	    	},
	    	form2: {
	    		phone: "",
	    		pwd: ""
	    	},
	    	form3: {
	    		phone: "",
	    		code: "",
	    		codeimg: "",
	    		smscode: "",
	    		password: "",
	    		password_confirmation: ""
	    	},
	    	isLocksubmit: false,
	    	isLocksubmit_checkimg: false,
	    	isPhone: true,
	    	isPhone2: true,
	    	isPwd: true,
	    	isCheckimg: true,
	    	isCheckimg3: true,
	    	sendCount: 0,
	    	sendCount3: 0,
	    	countInterval: null,
	    	isFindpwd: false,
	    	findSuccess: false
	    }
	},
	watch: {
		"$store.state.isShowlogin": function(val){
			let vm = this;
			vm.isShowlogin = vm.$store.state.isShowlogin;
		},
		"$store.state.loginType": function(val){
			let vm = this;
			vm.typei = vm.$store.state.loginType-1;
		}
	},
	created () {
		let vm = this;
		vm.isShowlogin = vm.$store.state.isShowlogin;
		vm.getCheckimg();
		vm.getCheckimg3();
		vm.$router.beforeResolve((to, from, next) => {
			if(to.matched[0].path=="/team"){
				vm.typei = 1
			}
			next()
		})
	},
	mounted () {
		let vm = this;
	},
	methods: {
		// 切换登录类型
		changeType: function(i){
			let vm = this;
			vm.typei = i;
		},
		// 获取验证码图片
		getCheckimg: function(){
			let vm = this;
			let imgurl = "/api/cpt/show?p=w&width=132&height=50&device_uuid=w&random="+Math.random()
			vm.form1.codeimg = vm.axios.defaults.baseURL + imgurl;
		},
		// 获取验证码图片-找回密码
		getCheckimg3: function(){
			let vm = this;
			let imgurl = "/api/cpt/show?p=w&width=132&height=50&device_uuid=w&random="+Math.random()
			vm.form3.codeimg = vm.axios.defaults.baseURL + imgurl;
		},
		// 检查手机号格式
		checkPhone: function(){
			let vm = this;
//			var reg = /^[1][0-9]{10}$/;
			let reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
			var val = vm.form1.phone;
			if(reg.test(val)){
				vm.isPhone = true;
				return true
			}else{
				vm.isPhone = false;
				vm.$Message.error("邮箱格式有误，请重新输入");
				return false
			}
		},
		// 检查手机号2格式
		checkPhone2: function(){
			let vm = this;
//			var reg = /^[1][0-9]{10}$/;
			let reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
			var val = vm.form2.phone;
			if(reg.test(val)){
				vm.isPhone2 = true;
				return true
			}else{
				vm.isPhone2 = false;
				vm.$Message.error("邮箱格式有误，请重新输入");
				return false
			}
		},
		// 检查手机号2格式
		checkPwd: function(){
			let vm = this;
			var val = vm.form2.pwd;
			if(val.trim()!=""){
				vm.isPwd = true;
				return true
			}else{
				vm.isPwd = false;
				vm.$Message.error("请输入秘密");
				return false
			}
		},
		// 验证图片验证码
		checkImg: function(){
			let vm = this;
			if(vm.form1.code && !vm.isLocksubmit_checkimg){
				vm.isLocksubmit_checkimg = true;
				vm.axios({
					method: 'get',
					url: '/api/cpt/check',
					params: {
						p: "w",
				    	device_uuid: "w",
				    	code: vm.form1.code
					}
				})
				.then(function(res){
					let o = res.data;
					vm.isLocksubmit_checkimg = false
					if(o.status==1){
						vm.isCheckimg = true;
//						vm.$Message.success("图片验证码输入正确");
					}else{
						vm.isCheckimg = false;
//						vm.$Message.error("图片验证码不符");
					}
				})
				.catch(function(res){
					vm.isLocksubmit_checkimg = false
				});
			}
		},
		// 验证图片验证码-找回密码
		checkImg3: function(){
			let vm = this;
			if(vm.form3.code && !vm.isLocksubmit_checkimg){
				vm.isLocksubmit_checkimg = true;
				vm.axios({
					method: 'get',
					url: '/api/cpt/check',
					params: {
						p: "w",
				    	device_uuid: "w",
				    	code: vm.form3.code
					}
				})
				.then(function(res){
					let o = res.data;
					vm.isLocksubmit_checkimg = false
					if(o.status==1){
						vm.isCheckimg3 = true;
//						vm.$Message.success("图片验证码输入正确");
					}else{
						vm.isCheckimg3 = false;
//						vm.$Message.error("图片验证码不符");
					}
				})
				.catch(function(res){
					vm.isLocksubmit_checkimg = false
				});
			}
		},
		// 发送短信验证码
		sendMsg: function(){
			let vm = this;
			if(vm.form1.phone.trim()==""){
				vm.$Message.warning("请输入邮箱");
				return
			}else if(vm.form1.code.trim()==""){
				vm.$Message.warning("请输入图片验证码");
				return
			}
			if(vm.sendCount==0 && !vm.isLocksubmit && vm.form1.phone){
				vm.isLocksubmit = true
				vm.axios({
					method: 'post',
					url: '/api/send_sms',
					data: {
						p: "w",
				    	device_uuid: "w",
				    	phone: vm.form1.phone,
				    	code: vm.form1.code
					}
				})
				.then(function(res){
					let o = res.data;
					vm.isLocksubmit = false
					if(o.status==1){
						// 设置短信锁定30s倒计时
						vm.sendCount = 60;
						clearInterval(vm.countInterval);
						vm.countInterval = setInterval(function(){
							if(vm.sendCount){
								vm.sendCount--
							}else{
								clearInterval(vm.countInterval);
								vm.sendCount = 0
							}
						},1000);
					}else{
						vm.$Message.error(o.msg);
						clearInterval(vm.countInterval);
						vm.sendCount = 0
					}
				})
				.catch(function(res){
					vm.isLocksubmit = false
				});
			}
		},
		// 发送短信验证码-找回密码
		sendMsg3: function(){
			let vm = this;
			if(vm.form3.phone.trim()==""){
				vm.$Message.warning("请输入邮箱");
				return
			}else if(vm.form3.code.trim()==""){
				vm.$Message.warning("请输入图片验证码");
				return
			}
			if(vm.sendCount3==0 && !vm.isLocksubmit && vm.form3.phone){
				vm.isLocksubmit = true
				vm.axios({
					method: 'post',
					url: '/api/send_sms',
					data: {
						p: "w",
				    	device_uuid: "w",
				    	phone: vm.form3.phone,
				    	code: vm.form3.code
					}
				})
				.then(function(res){
					let o = res.data;
					vm.isLocksubmit = false
					if(o.status==1){
						// 设置短信锁定30s倒计时
						vm.sendCount3 = 60;
						clearInterval(vm.countInterval);
						vm.countInterval = setInterval(function(){
							if(vm.sendCount3){
								vm.sendCount3--
							}else{
								clearInterval(vm.countInterval);
								vm.sendCount3 = 0
							}
						},1000);
					}else{
						vm.$Message.error(o.msg);
						clearInterval(vm.countInterval);
						vm.sendCount = 0
					}
				})
				.catch(function(res){
					vm.isLocksubmit = false
				});
			}
		},
		// 登录-个人用户
		submit: function(){
			let vm = this;
			if(!vm.isLocksubmit && vm.form1.phone && vm.form1.smscode && vm.isPhone){
				vm.isLocksubmit = true
				vm.axios({
					method: 'post',
					url: '/api/users/auto_token',
					data: {
						p: "w",
				    	phone: vm.form1.phone,
				    	smscode: vm.form1.smscode
					}
				})
				.then(function(res){
					let o = res.data;
					vm.isLocksubmit = false
					if(o.status==1){
						localStorage.setItem("personal_nickname",o.data.nickname)
						localStorage.setItem("personal_api_token",o.data.api_token)
						vm.$store.commit("updateToken");
						vm.$store.commit("hideLogin");
						vm.$Message.success({
							content: "登录成功",
							onClose: function(){
								vm.$router.push({
									path: '/personal'
								})
							}
						});
					}else{
						vm.$Message.error("登录失败");
					}
				})
				.catch(function(res){
					vm.isLocksubmit = false
				});
			}
		},
		// 登录-团体用户
		submit2: function(){
			let vm = this;
			if(!vm.isLocksubmit && vm.form2.phone && vm.isPhone2 && vm.isPwd){
				vm.isLocksubmit = true
				vm.axios({
					method: 'post',
					url: '/api/teamusers/login',
					data: {
						p: "w",
				    	phone: vm.form2.phone,
				    	password: vm.form2.pwd
					}
				})
				.then(function(res){
					vm.form2.phone = "";
					vm.form2.pwd = "";
					let o = res.data;
					vm.isLocksubmit = false
					if(o.status==1){
						localStorage.setItem("nickname",o.data.nickname)
						localStorage.setItem("api_token",o.data.api_token)
						vm.$store.commit("updateToken");
						vm.$store.commit("hideLogin");
						if(o.data.team_status==2){
							vm.$Message.success({
								content: "登录成功",
								onClose: function(){
									vm.$router.push({
										path: '/team'
									})
								}
							});
						}else{
							vm.$router.push({
								path: '/team/info'
							})
						}
					}else{
						vm.$Message.error(o.msg);
					}
				})
				.catch(function(res){
					vm.isLocksubmit = false
				});
			}
		},
		// 提交-找回密码
		submit3: function(){
			let vm = this;
			if(vm.form3.password!=vm.form3.password_confirmation){
				vm.$Message.warning("密码输入不一致")
				return
			}
			if(!vm.isLocksubmit && vm.form3.phone && vm.form3.smscode && vm.form3.password && vm.form3.password==vm.form3.password_confirmation){
				vm.isLocksubmit = true
				vm.axios({
					method: 'post',
					url: '/api/teamusers/password',
					data: {
						p: "w",
				    	phone: vm.form3.phone,
				    	smscode: vm.form3.smscode,
				    	password: vm.form3.password,
				    	password_confirmation: vm.form3.password_confirmation
					}
				})
				.then(function(res){
					let o = res.data;
					vm.isLocksubmit = false
					if(o.status==1){
						vm.form3.phone = "";
						vm.form3.codeimg = "";
						vm.form3.smscode = "";
						vm.form3.password = "";
						vm.form3.password_confirmation = "";
						vm.findSuccess = true;
					}else{
						vm.$Message.error(o.msg);
					}
				})
				.catch(function(res){
					vm.isLocksubmit = false
				});
			}
		},
		// 找回密码
		findPwd: function(){
			let vm = this;
			vm.typei = 2;
		},
		// 找回密码，立即登录
		toTeamlogin: function(){
			let vm = this;
			vm.isFindpwd = false;
			vm.typei = 1;
			vm.findSuccess = false;
		},
		// 注册团体账号
		regTeam: function(){
			let vm = this;
			vm.$store.commit("hideLogin");
			vm.$router.push({
				path: '/team/reg'
			})
		},
		// 关闭登录弹窗
		closeLogin: function(){
			let vm = this;
			vm.$store.state.loginType = 999;
			vm.$store.commit("hideLogin");
			if(!localStorage.getItem("api_token")){
				window.location.reload();
			}
		}
	}
}
</script>

<style scoped lang="scss">
@import "@/style/theme.scss";
.login{
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 100;
	background-color: rgba(0,0,0,0.7);
	.center{
		width: 800px;
		height: auto;
		/*min-height: 540px;*/
		padding: 35px 0;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		background-color: #fff;
		border-radius: 10px;
		.title{
			font-size: 24px;
			line-height: 150%;
			text-align: center;
			color: #55555A;
		}
		.type{
			width: 360px;
			height: 56px;
			margin: 25px auto 0;
			padding: 8px;
			background-color: #F2F2F2;
			border-radius: 28px;
			display: flex;
			justify-content: space-between;
			li{
				width: 165px;
				height: 40px;
				border-radius: 20px;
				background-color: rgba(255,255,255,0);
				font-size: 18px;
				line-height: 40px;
				text-align: center;
				color: #AAAAB0;
				cursor: pointer;
				transition: all .2s ease-out 0s;  
				&:hover,
				&.on{
					background-color: rgba(255,255,255,1);
					color: #55555A;
				}
			}
		}
		.form{
			width: 510px;
			height: auto;
			margin: 45px auto 0;
			li{
				width: 100%;
				height: auto;
				margin-bottom: 20px;
				padding-left: 110px;
				position: relative;
				.c1{
					width: 84px;
					height: 50px;
					position: absolute;
					top: 0;
					left: 0;
					font-size: 16px;
					line-height: 50px;
					color: #282828;
					text-align: justify;
					&:after {
			            display: inline-block;
			            width: 100%;
			            content: '';
			            height: 0;
			        }
				}
				.c2{
					display: flex;
					justify-content: space-between;
					input{
						display: block;
						width: 100%;
						height: 50px;
						padding: 0 10px;
						background: none;
						outline: none;
						border: 1px solid #ddd;
						border-radius: 4px;
						font-size: 16px;
						line-height: 48px;
						color: #282828;
						&:focus,
						&.error{
							border-color: #E65439;
						}
						&.short{
							width: 250px;
						}
					}
					img.codeimg{
						display: block;
						width: 132px;
						height: 50px;
						transition: all .2s ease-out 0s;
						cursor: pointer;
						&:active{
							transform: scale(1.05);
						}
					}
					a.sendcode{
						display: block;
						width: 132px;
						height: 50px;
						background-color: $base-color;
						border-radius: 5px;
						font-size: 16px;
						line-height: 50px;
						color: #fff;
						text-align: center;
						&:hover{
							background-color: $base-color;
						}
						&:active{
							transform: scale(1.05);
						}
						&.gray{
							background-color: #b9b1b1;
						}
					}
				}
				.findpwd{
					padding-top: 10px;
					text-align: right;
					a{
						font-size: 14px;
						line-height: 150%;
						color: $base-color;
					}
				}
			}
		}
		button.submit{
			display: block;
			width: 240px;
			height: 50px;
			margin: 43px auto 0;
			background-color: $base-color;
			outline: none;
			border: none;
			border-radius: 25px;
			font-size: 16px;
			line-height: 50px;
			color: #fff;
			text-align: center;
			transition: all .2s ease-out 0s;
			cursor: pointer;
			&:hover{
				background-color: $base-color;
			}
			&:active{
				transform: scale(1.05);
			}
		}
		.regtip{
			margin-top: 10px;
			font-size: 14px;
			line-height: 150%;
			color: #999;
			text-align: center;
			a{
				color: $base-color;
			}
		}
		a.close{
			display: block;
			width: 40px;
			height: 40px;
			position: absolute;
			top: 30px;
			right: 30px;
			&:hover{
				/deep/ .ivu-icon{
					color: #C7251E !important;
				}
			}
			&:active{
				transform: scale(1.1);
			}
		}
		.findsuccess{
			padding: 100px 0;
			.tip{
				padding-bottom: 100px;
				display: flex;
				justify-content: center;
				img{
					display: inline-block;
					width: 48px;
					height: 48px;
				}
				span{
					margin-left: 25px;
					font-size: 22px;
					line-height: 48px;
					color: #555;
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/common/login.vue